import React, { Fragment, useEffect, useState } from "react";
import Stepper from "../../../components/Stepper";
import arrow_left from "../../../assets/images/arrow-left.svg";
import exit from "../../../assets/images/exit.svg";
import { Box, FormControl, TextField } from "@material-ui/core";
import ErrorPopUp from "../../../components/ErrorPopUp";
import { useSelector } from "react-redux";

const PaymentVoucher = (props) => {
	const {
		handleClose,
		setPanelContent,
		setPayByVoucher,
		paymentMethod,
		t,
		getVoucherPayment,
		voucherMsg,
		errorMessageHandlerVoucher,
	} = props;

	const [activeStep, setActiveStep] = React.useState(0);
	const [voucherCode, setVoucherCode] = React.useState("");
	const [error, setError] = useState(false);
	const [openErrorPopUp, setOpenErrorPopUp] = useState(false);
	const [clicked, setClicked] = useState(false);
	const [errorForVoucher, setErrorForVoucher] = useState(
		errorMessageHandlerVoucher,
	);

	const { isTourist } = useSelector(
		(state) => state.BalanceReducer.payloadAfterLogIn,
	);

	const handleChangeVoucher = (e) => {
		setVoucherCode(!isNaN(e.target.value) ? e.target.value : "");
	};

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};
	const handleBack = () => {
		if (activeStep !== 0) {
			setActiveStep((prevActiveStep) => prevActiveStep - 1);
		} else {
			setPanelContent(true);
			setPayByVoucher(false);
		}
	};

	useEffect(() => {
		if (voucherCode.length < 16 && voucherCode !== "") {
			setError(true);
			setClicked(false);
		} else {
			setError(false);
		}
	}, [voucherCode]);

	useEffect(() => {
		if (voucherMsg && !error) {
			setClicked(false);
			handleNext();
		} else if (errorMessageHandlerVoucher && voucherCode !== "") {
			setOpenErrorPopUp(false);
			setClicked(false);
			setErrorForVoucher(false);
		} else if (errorMessageHandlerVoucher) {
			setClicked(false);
			setOpenErrorPopUp(true);
		}
	}, [voucherMsg, error, errorMessageHandlerVoucher]);

	let temp = null;
	if (activeStep === 0) {
		temp = (
			<Fragment>
				<span className="modalTitle">
					<a
						className="goBack hidden nextStep stepBackAlign"
						onClick={handleBack}
					>
						<img src={arrow_left} alt={t("arrow_left")} />
					</a>
					{isTourist ? t("billPayment") : t("paymentAndRenewal")}
				</span>
				<Stepper t={t} paymentMethod={paymentMethod} activeStep={activeStep} />
				<div className="paymentContent firstElement">
					<div className="removePayments">
						<div className="paymentContentTitle">
							{t("paymentWith16Digits")}
						</div>
						<div className="paymentContentTitle">
							{t("caseOfPaymentWithRenewalCard")}
						</div>
						<div className="paymentContentTitle">
							{t("caseOfPaymentVoucher")}
						</div>
						<div className="paymentMethod">
							<div className="paymentDetails noPadding">
								<div className="paymentContentTitle textb">
									{t("titleFor16DigitInput")}
								</div>
								<div>
									<Box component="form" noValidate autoComplete="off">
										<FormControl fullWidth sx={{ m: 1 }} variant="filled">
											<TextField
												error={error}
												helperText={error ? t("voucherErrorMessage") : ""}
												id={
													error
														? "filled-error-helper-text"
														: "filled-adornment-amount"
												}
												type="text"
												label={t("inputFormTitle")}
												value={voucherCode}
												onChange={handleChangeVoucher}
												inputProps={{ maxLength: 16, minLength: 16 }}
												variant="filled"
											/>
										</FormControl>
									</Box>
								</div>
							</div>
						</div>
					</div>
					<div className="buttonOuter inlineButtons rightAligned">
						<a
							onClick={(e) => {
								setClicked(true);
								if (voucherCode.length === 16) {
									e.preventDefault();
									getVoucherPayment(voucherCode);
								} else {
									setError(true);
								}
							}}
							className={
								clicked
									? "button primaryButton primaryButtonNormal disabled"
									: "button" + " primaryButton primaryButtonNormal"
							}
						>
							{t("continue")}
							<span className="loadingSpinner"></span>
						</a>
					</div>
					<img
						src={exit}
						className="close"
						onClick={handleClose}
						alt={t("close")}
					/>
				</div>
			</Fragment>
		);
	} else {
		temp = (
			<Fragment>
				<span className="modalTitle">
					{isTourist ? t("billPayment") : t("paymentAndRenewal")}
				</span>
				<Stepper paymentMethod={paymentMethod} t={t} activeStep={activeStep} />
				<div className="paymentContent firstElement">
					<div className="removePayments">
						<div className="paymentContentSuccess textc second-element-spacer">
							{t("congratsMessage")}
						</div>
						<div className="paymentContentSuccess second-element-spacer">
							<p>{t("congratsContent")}</p>
							<p>{t("congratsContentParagraph")}</p>
						</div>
					</div>
					<div className="buttonOuter inlineButtons textCenter">
						<a
							onClick={() => {
								window.location.href = "/";
							}}
							className="button primaryButton primaryButtonNormal"
						>
							{t("returnHome")}
							<span className="loadingSpinner"></span>
						</a>
					</div>
					<img
						src={exit}
						className="close"
						onClick={handleClose}
						alt={t("close")}
					/>
				</div>
			</Fragment>
		);
	}

	return (
		<Fragment>
			{temp}
			{errorForVoucher ? (
				<ErrorPopUp
					setOpenErrorPopUp={setOpenErrorPopUp}
					openErrorPopUp={openErrorPopUp}
					t={t}
					text={t("errorGeneral")}
				/>
			) : null}
		</Fragment>
	);
};

export default PaymentVoucher;
